import { useMemo, useState, useEffect, useRef, useCallback } from "react";
import { cdnImg } from "../Utils/cdnImage";
import Layout from "./Layout";
import FilterCasino from "./casino/FilterCasino";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { isEmpty, lowerCase, startCase, toLower } from "lodash";
import {
  AracadeNew,
  CarshNew,
  CasinoNew,
  FishingNew,
  gamesLiveArray,
  LottoNew,
  SlotNew,
  TableNew,
} from "./casino/FilterList";
import CasinoSearch from "./casino/CasinoSearch";
import { t } from "i18next";
import ThemeContext from "../context/ThemeContext";
import { toast } from "react-toastify";
import { isMobile } from "react-device-detect";
import { AnimatePresence, motion } from "framer-motion";
import { useInfiniteScroll } from "../component/useInfiniteScroll";
import { HomeTabData } from "./casino/ListHome";

const PAGE_SIZE = 15;
const LOAD_MORE_SIZE = 10;

const Casino = () => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const theme = useContextSelector(ThemeContext, (ctx) => ctx.theme);
  const setCasinoBefore = useContextSelector(
    AuthContext,
    (ctx) => ctx.setCasinoBefore,
  );
  const launchCasino = useContextSelector(
    AuthContext,
    (ctx) => ctx.launchCasino,
  );

  const location = useLocation();
  const [input, setInput] = useState("");
  const [show, setShow] = useState(false);
  const [active, setActive] = useState("");
  const [activeInner, setActiveInner] = useState("");
  const [visibleData, setVisibleData] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  const loadingRef = useRef(false);
  const timerRef = useRef(null);
  const listRef = useRef([]);
  const filterEpochRef = useRef(0);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const type = params.get("type") || "";
    const provider = params.get("provider") || "";
    if (!isEmpty(provider)) setActiveInner(provider);
    if (!isEmpty(type)) setActive(lowerCase(type));
  }, [location.search]);

  const object = {
    casino: CasinoNew,
    slots: SlotNew,
    table: TableNew,
    crash: CarshNew,
    fishing: FishingNew,
    arcade: AracadeNew,
    lottery: LottoNew,
    hot: HomeTabData?.hot,
  };

  const AllArray = [
    TableNew,
    CasinoNew,
    SlotNew,

    CarshNew,
    FishingNew,
    AracadeNew,
    LottoNew,
  ].flat();

  const AllCasino = (data) => {
    const seen = new Set();
    return data.filter((item) => {
      if (seen.has(item.casinoType)) return false;
      seen.add(item.casinoType);
      return true;
    });
  };

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    filterEpochRef.current += 1;
    loadingRef.current = false;
    let result = [];
    if (active == "all") {
      result = AllArray;
      if (!isEmpty(activeInner) && activeInner !== "all") {
        result = AllArray.filter(
          (res) => res?.platForm === activeInner && !isEmpty(res?.casinoType),
        );
      }

      if (!isEmpty(input)) {
        const search = input?.toLowerCase().trim() || "";
        result = AllArray?.filter((res) => {
          return res?.name?.toLowerCase().includes(search);
        });
      }
    } else {
      result = object[active] || [];

      if (!isEmpty(activeInner) && activeInner !== "all") {
        result = result.filter(
          (res) => res?.platForm === activeInner && !isEmpty(res?.casinoType),
        );
      }

      if (!isEmpty(input)) {
        const search = input?.toLowerCase().trim() || "";
        result = AllArray?.filter((res) => {
          return res?.name?.toLowerCase().includes(search);
        });
      }
    }
    listRef.current = result;
    setVisibleData(result.slice(0, PAGE_SIZE));
    setHasMore(result.length > PAGE_SIZE);
  }, [active, activeInner, input]);

  const loadMore = useCallback(() => {
    if (loadingRef.current) return;
    loadingRef.current = true;

    const epochAtCall = filterEpochRef.current;

    timerRef.current = setTimeout(() => {
      timerRef.current = null;

      if (epochAtCall !== filterEpochRef.current) {
        loadingRef.current = false;
        return;
      }

      const currentList = listRef.current;

      setVisibleData((prev) => {
        if (prev.length >= currentList.length) {
          setHasMore(false);
          loadingRef.current = false;
          return prev;
        }

        const nextData = currentList.slice(0, prev.length + LOAD_MORE_SIZE);
        if (nextData.length >= currentList.length) {
          setHasMore(false);
        }
        loadingRef.current = false;
        return nextData;
      });
    }, 300);
  }, []);

  const loaderRef = useInfiniteScroll(loadMore, hasMore);

  const handel = (res) => {
    if (!isEmpty(user)) {
      if (isEmpty(res?.platFormCode)) {
        toast.error(t("ComingSoon"));
      } else {
        launchCasino({
          platForm: res?.platFormCode,
          gameType: res?.gameType,
          casinoType: res?.casinoType,
          isLobbyTrue: res?.isLobbyTrue,
          gameTableId: res?.tableId || "",
        });
      }
    } else {
      setCasinoBefore(true);
    }
  };

  return (
    <Layout>
      <div className="content-main ng-star-inserted">
        <div className="content-box">
          <div className="games">
            <div className="ng-tns-c2684251700-888 ng-star-inserted">
              {isMobile && (
                <div className="search-top-block ng-tns-c2684251700-888 ng-star-inserted">
                  <div className="search-top-info ng-tns-c2684251700-888">
                    <input
                      value={input}
                      onClick={() => {
                        setShow(true);
                        setActiveInner("all");
                      }}
                      type="text"
                      className="ng-tns-c2684251700-888 ng-untouched ng-pristine ng-valid ng-star-inserted"
                      placeholder={t("SearchGames")}
                    />
                  </div>
                </div>
              )}

              {show && (
                <CasinoSearch
                  input={input}
                  setInput={setInput}
                  active={active}
                  setActive={setActive}
                  activeInner={activeInner}
                  setActiveInner={setActiveInner}
                  setShow={setShow}
                />
              )}
            </div>

            <div className="ng-tns-c3892969999-131 row-reverse ng-star-inserted">
              {!["hot"].includes(active) && (
                <FilterCasino
                  active={active}
                  setActive={setActive}
                  activeInner={activeInner}
                  setActiveInner={setActiveInner}
                  setShow={setShow}
                />
              )}
              <div className="sort-bar ng-tns-c3892969999-131 ng-star-inserted">
                <div className="sort-bar__title ng-tns-c3892969999-131">
                  {["hot"].includes(active) ? (
                    <span
                      style={{ color: "white" }}
                      className="ng-tns-c3892969999-131"
                    >
                      {startCase(active)}
                    </span>
                  ) : (
                    <span
                      style={{ color: "white" }}
                      className="ng-tns-c3892969999-131"
                    >
                      {startCase(active)}
                      {!isEmpty(activeInner)
                        ? ` - ${startCase(activeInner)}`
                        : ""}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <AnimatePresence>
              {visibleData?.length > 0 ? (
                <div className="games-main">
                  {visibleData.map((res, index) => (
                    <motion.div
                      // FIX: use a stable unique key, not the object reference
                      key={`${res?.platForm}-${res?.casinoType}-${res?.name}-${index}`}
                      initial={{ opacity: 0, y: 40 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -20 }}
                      transition={{ duration: 0.3 }}
                    >
                      <div
                        onClick={() => handel(res)}
                        className="games-box ng-tns-c2986684299-9 ng-trigger ng-trigger-staggerFadeAnimation"
                      >
                        <div className="pic item-ani ng-tns-c2986684299-9">
                          <a className="ng-tns-c2986684299-9">
                            <img
                              className="ng-tns-c2986684299-9 ng-star-inserted"
                              alt={res?.name}
                              src={
                                res?.img == "/assets/Slot/KM-TABLE-015.webp"
                                  ? "/assets/Slot/KM-TABLE-015.webp"
                                  : cdnImg(res?.img || res?.src)
                              }
                              loading="lazy"
                            />
                          </a>
                        </div>
                        <div className="text item-ani ng-tns-c2986684299-9">
                          <h3 className="ng-tns-c2986684299-9">{res?.name}</h3>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              ) : (
                <motion.div
                  key="empty"
                  initial={{ opacity: 0, y: 40 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="iplimit-card-wrap games-empty-container ng-star-inserted">
                    <div style={{ color: "white" }} className="top-inner">
                      <h3>{t("SORRY")}</h3>
                      <h4>
                        {t("SorryLow")},<br />
                        {t("SorryNoGames")}
                      </h4>
                      <div className="button btn-primary">
                        <Link to="/">{t("BackButton")}</Link>
                      </div>
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            {hasMore && (
              <div ref={loaderRef} className="list-loading ng-star-inserted" />
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Casino;
